import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { from, map } from 'rxjs';
import { LocalDatabaseService } from '../services/local-database.service';
import { OauthService } from '../services/oauth.service';

export const permissionGuard: CanActivateFn = (route) => {
  const required = route.data['permissions'] as unknown;
  if (!Array.isArray(required) || !required.length) {
    return true;
  }

  const db = inject(LocalDatabaseService);
  const router = inject(Router);

  inject(OauthService).syncSession().subscribe();

  return from(db.getCurrentLoggedUser()).pipe(
    map((user) =>
      user?.permissions?.some((permission) => required.includes(permission))
        ? true
        : router.createUrlTree(['/inicio'])
    )
  );
};
